import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';

import { IOption, IStatusOption } from 'interfaces';

import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { warehouseService } from 'services/api';
import { useState } from 'react';
import { Typography } from '@mui/material';

interface FormParams {
  onSubmit: any;
  products: IOption[];
  categories: IOption[];
  statusOptions: IStatusOption[];
  labelOptions: IOption[];
  warehouseId?: number | null;
  initialValues?: any;
}
function ProductWarehouseForm(params: FormParams) {
  const {
    labelOptions,
    statusOptions,
    products,
    categories,
    onSubmit,
    warehouseId,
    initialValues
  } = params;
  const hasInitialProduct = initialValues?.product !== undefined;
  const [warehouseCode, setWarehouseCode] = useState<string>('');
  const { t } = useTranslation();

  if (warehouseId) {
    warehouseService.get(warehouseId).then((res) => {
      if (res) {
        setWarehouseCode(res.code);
      }
    });
  }

  const handleSubmit = (values: any) => {
    const productValue = initialValues?.product;

    const updatedValues = {
      ...values,
      product: hasInitialProduct ? productValue : values.product
    };

    onSubmit(updatedValues);
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {t('global.warehouse')}: {warehouseCode}
      </Typography>
      <ReactFinalForm
        onSubmit={handleSubmit}
        formId="addProductThreshold"
        hideControls
        initialValues={initialValues}>
        <div className="grid gap-2 p-2">
          {!hasInitialProduct && products && (
            <IdentityField
              name="product"
              component={AutocompleteAdapter}
              options={products}
              optionLabel="description"
              label={t('global.product')}
            />
          )}

          <div className="grid grid-cols-2 gap-2">
            {categories && (
              <IdentityField
                name="category"
                label={t('global.category')}
                component={AutocompleteAdapter}
                options={categories}
                optionValue="code"
                placeholder="Category"
              />
            )}

            {statusOptions && (
              <IdentityField
                name="status"
                label={t(`entities.product.status`)}
                component={AutocompleteAdapter}
                options={statusOptions}
                placeholder="Status"
                type="text"
                optionLabel="translated_display_name"
                optionValue="value"
              />
            )}
          </div>
          <div className=" grid grid-cols-4 gap-2">
            <div className="">
              <IdentityField
                name="label"
                component={AutocompleteAdapter}
                options={labelOptions}
                label={t('global.label')}
              />
            </div>
            <div className="">
              <IdentityField
                name="understock_threshold"
                component={TextFieldAdapter}
                label={t('entities.product.understock_threshold')}
                type="number"
              />
            </div>
            <div className="">
              <IdentityField
                name="overstock_threshold"
                component={TextFieldAdapter}
                label={t('entities.product.overstock_threshold')}
                type="number"
              />
            </div>
            <div className="">
              <IdentityField
                name="restock_threshold"
                component={TextFieldAdapter}
                label={t('entities.product.restock_threshold')}
                type="number"
              />
            </div>
          </div>
        </div>
        <div className="w-full gap-2 p-2">
          <IdentityField
            name="notes"
            component={TextFieldAdapter}
            label={t('global.notes')}
            type="text"
          />
        </div>
      </ReactFinalForm>
    </div>
  );
}

export default ProductWarehouseForm;
